module.exports = __webpack_public_path__ + "img/ETHW.28a6465f.png";